export const MIAOLIN_CUSTOMER_ONBOARDING_FORM_ID =
  '8c0f4b2a-6a7d-4f4c-9c3e-5d9b8f2a1040'

export const MIAOLIN_LEGACY_CUSTOMER_ONBOARDING_FORM_IDS = [
  '33333333-3333-4333-8333-333333333333',
] as const

export function normalizeMiaolinCustomerOnboardingFormId(formId: string) {
  return MIAOLIN_LEGACY_CUSTOMER_ONBOARDING_FORM_IDS.includes(
    formId as (typeof MIAOLIN_LEGACY_CUSTOMER_ONBOARDING_FORM_IDS)[number],
  )
    ? MIAOLIN_CUSTOMER_ONBOARDING_FORM_ID
    : formId
}
